<h3 mat-dialog-title>Ajouter un groupe</h3>
<mat-dialog-content class="caaks-dialog-text">
  <div>Renseigner les informations suivantes.</div>
  <div>
    <form [formGroup]="groupForm" novalidate>
      <div>

        <mat-form-field>
          <input matInput formControlName="name" placeholder="Nom du groupe" required />
          @if (name!.hasError('uniqueName')) {
            <mat-error>
              Un groupe existe déjà avec cenom.
            </mat-error>
          }
          @if (name!.hasError('required')) {
            <mat-error> Le nom du groupe est requis. </mat-error>
          }
        </mat-form-field>


      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container>
    <button mat-button type="submit" color="primary" [disabled]="isCreateDisabled()" (click)="add()">Créer</button>
    <button mat-button (click)="cancel()">Annuler</button>
  </ng-container>
</mat-dialog-actions>